import { LazyLoadImage } from 'react-lazy-load-image-component';

const AppLazyLoadedImg = ({ src, alt, className }: { src: string; alt?: string; className?: string }) => {
    return <LazyLoadImage src={src} alt={alt} className={className} />;
};

export default AppLazyLoadedImg;
